import React from "react";

const SentinelFooter = () => (
  <footer>
    <div className="wrap">
      <div className="foot-grid">
        <div>
          <a className="logo" href="#top" style={{ marginBottom: 16 }}>
            <span className="logo-mark" aria-hidden="true">
              <svg viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 2 L36 8 V22 C36 33 29 40 20 42.5 C11 40 4 33 4 22 V8 Z" fill="#C39A54" />
                <path d="M20 9 L22.6 18.4 L31 21 L22.6 23.6 L20 33 L17.4 23.6 L9 21 L17.4 18.4 Z" fill="#142744" />
              </svg>
            </span>
            <span className="logo-word">NORTHSTAR<span>{"\u00A0SERVICE PARTNERS"}</span></span>
          </a>
          <p style={{ marginTop: 14, maxWidth: "34ch" }}>
            Acquiring and building the best security integration companies in western North America
            and Canada — for the long term.
          </p>
        </div>
        <div>
          <h4>Company</h4>
          <ul>
            <li><a href="#why">Why Northstar</a></li>
            <li><a href="#approach">Our Approach</a></li>
            <li><a href="#process">Selling to Us</a></li>
            <li><a href="#faq">FAQ</a></li>
          </ul>
        </div>
        <div>
          <h4>Contact</h4>
          <ul>
            <li><a href="mailto:info@northstarservicepartners.com">info@northstarservicepartners.com</a></li>
            <li><a href="#contact">Start a conversation</a></li>
            <li>Langley, British Columbia</li>
          </ul>
        </div>
      </div>
      <div className="foot-bottom">
        <span>© 2026 NORTHSTAR SERVICE PARTNERS</span>
        <span>SECURING WHAT YOU BUILT</span>
      </div>
    </div>
  </footer>
);

export default SentinelFooter;
